import React, { useState } from 'react';
import './settings.scss';
import { useForm } from 'react-hook-form';
import classNames from 'classnames';
import { useIntl } from 'react-intl';
import { Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import FieldDTO from '../../../components/fields/Abstract/FieldDTO';
import TextInputWithLabel from '../../../components/fields/TextInput/TextInputWithLabel';
import { toLinear } from '../../../utils/utils';
import CameraDTO from '../../../dto/CameraDTO';
import TextInput from '../../../components/fields/TextInput/TextInput';
import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from '../../../components/base/Dialog/Dialog';

export default function CoordinateConverter(props) {
  const { onChange = () => {} } = props;
  const [open, setOpen] = useState(false);
  const intl = useIntl();
  const { formatMessage } = intl;

  const onShow = () => setOpen(true);
  const onHide = () => setOpen(false);

  const {
    reset,
    getValues,
    register,
  } = useForm({
    mode: 'onBlur',
    defaultValues: {},
    resetOptions: {
      keepDirtyValues: true, // user-interacted input will be retained
      keepErrors: true, // input errors will be retained with value update
    },
  });

  const handleSave = () => {
    const values = getValues();
    onChange(toLinear(values));
    onHide();
    reset();
  };

  return (
    <>
      <Button variant="link" className="convert-coordinate-button" onClick={onShow}><Icons width={18} height={20} customIcon icon="convert" className="button-icons" /></Button>
      <Dialog
        className={classNames('convert-coordinate-dialog')}
        onClose={onHide}
        open={open}
      >
        <DialogTitle header={formatMessage({ id: 'select.coordinates' })} title={<Icons onClick={onHide} customIcon icon="close" className="close" />} />
        <DialogContent className="cc-content">
          <div className="degrees-coordinates">
            <div className="dc-row">
              <TextInputWithLabel
                variant="material"
                label={formatMessage({ id: 'longitude' })}
                inputProps={{ ...register('longitude.deg') }}
              />
              <TextInput
                variant="material"
                inputProps={{ ...register('longitude.min') }}
              />
              <TextInput
                variant="material"
                inputProps={{ ...register('longitude.sec') }}
              />
            </div>
            <div className="dc-row mt-3">
              <TextInputWithLabel
                variant="material"
                label={formatMessage({ id: 'latitude' })}
                inputProps={{ ...register('latitude.deg') }}
              />
              <TextInput
                variant="material"
                inputProps={{ ...register('latitude.min') }}
              />
              <TextInput
                variant="material"
                inputProps={{ ...register('latitude.sec') }}
              />
            </div>
          </div>
        </DialogContent>
        <DialogFooter className="hff-footer">
          <div className="hff-footer-buttons">
            <Button className="hff-clear-show" onClick={handleSave}>{formatMessage({ id: 'app.save' })}</Button>
            <Button className="hff-clear-data" variant="secondary" onClick={onHide}>{formatMessage({ id: 'app.cancel' })}</Button>
          </div>
        </DialogFooter>
      </Dialog>
    </>
  );
}
